export default {
  navigationBarTitleText: '专属权益'
};
